import React from 'react';
import { motion } from 'framer-motion';
export const FloatingContactButton = () => {
  return <motion.a href="sms:9093717021" className="fixed bottom-6 right-6 z-50 flex items-center justify-center w-16 h-16 bg-accent text-white rounded-full shadow-[0_8px_30px_rgb(0,0,0,0.3)] hover:bg-[#b56408] transition-colors focus:outline-none focus:ring-4 focus:ring-accent/50" initial={{
    scale: 0,
    opacity: 0
  }} animate={{
    scale: 1,
    opacity: 1
  }} transition={{
    type: 'spring',
    stiffness: 260,
    damping: 20,
    delay: 0.5
  }} whileHover={{
    scale: 1.1
  }} whileTap={{
    scale: 0.9
  }} aria-label="Message us" data-id="element-75">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="w-8 h-8" data-id="element-76">
        <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" data-id="element-77" />
      </svg>
    </motion.a>;
};